/* lg-motion.js (Scout 22/10/2026): brings blogs, recipes, product copy and pages in line with the
   collection copy style: highlighter links, lead line, headings that draw in, ticks that pop, staggered cards.
   Styling only: no words, links or order change. */
(function(){
  var RM=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SEL='#main .rte, #main .lg-recipe__body, #main .lg-story__body, #main .lg-aprose, #main .lg-pdp-copy';
  var SKIP='.lgy, .lgx-links, .lgy-chips, [class*=jdgm], [class*=lgr-], .lg-card, header, footer, nav, button, .button';
  function run(){
    var roots=[].slice.call(document.querySelectorAll(SEL)).filter(function(r){return !r.closest('.lgy')&&!r.parentElement.closest(SEL);});
    var rv=[];
    roots.forEach(function(root){
      if(root.dataset.lgm) return; root.dataset.lgm='1'; root.classList.add('lgm');
      /* links inside running copy */
      [].forEach.call(root.querySelectorAll('p a, li a, td a'),function(a){
        if(a.closest(SKIP)||a.querySelector('img')||!a.textContent.trim()||(a.getAttribute('href')||'').charAt(0)==='#'||getComputedStyle(a).display!=='inline') return;
        a.classList.add('lgm-ln');
        if(a.closest('.lg--black, .lgx-card--ours, .lgx-vs>div:last-child, .lgx-fact, .callout--dark')) a.classList.add('lgm-ln--dark');
      });
      /* lead line: first real paragraph that is a direct child */
      var first=[].filter.call(root.children,function(c){return c.tagName==='P'&&c.textContent.trim().length>80;})[0];
      if(first&&first===[].filter.call(root.children,function(c){return /^(P|H2|H3|DIV|UL|OL|FIGURE|TABLE)$/.test(c.tagName);})[0]){first.classList.add('lgm-lead');rv.push(first);}
      /* headings draw a gold rule */
      [].forEach.call(root.querySelectorAll('h2, h3'),function(h){if(h.closest('.lgx-answer, .lgx-card, .lgx-faq, .lgx-vs, .lgx-fact, summary')) return;h.classList.add('lgm-h');rv.push(h);});
      /* ticks pop, cards and facts stagger */
      [].forEach.call(root.querySelectorAll('ul.lgx-ticks>li, .lgx-cards>.lgx-card, .lgx-facts>.lgx-fact, .lgx-steps>li'),function(n){n.classList.add('lgm-st');rv.push(n);});
    });
    if(!rv.length) return;
    if(RM||!('IntersectionObserver' in window)){rv.forEach(function(n){n.classList.add('in');});return;}
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting) return;var n=e.target;
      if(n.classList.contains('lgm-st')){var i=[].indexOf.call(n.parentNode.children,n);n.style.transitionDelay=Math.min(i,6)*80+'ms';}
      n.classList.add('in');io.unobserve(n);});},{rootMargin:'0px 0px -8% 0px'});
    rv.forEach(function(n){n.classList.add('lgm-pre');io.observe(n);});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();
